export { default as CommentReply } from './CommentReply'
export { default as NewComment } from './NewComment'
export { default as SingleComment } from './SingleComment'


// WEBPACK FOOTER //
// ./src/js/views/Article/components/Comments/components/index.js